import { render, staticRenderFns } from "./RecoverPassword.vue?vue&type=template&id=03b23490&scoped=true"
import script from "./RecoverPassword.vue?vue&type=script&lang=js"
export * from "./RecoverPassword.vue?vue&type=script&lang=js"
import style0 from "./RecoverPassword.vue?vue&type=style&index=0&id=03b23490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b23490",
  null
  
)

export default component.exports